import { Loading } from 'framework/ui/mui-builder';
import { FormShowTemplate } from 'framework/form';
import { ShowPageLayout } from 'framework/ui/layout';
import MainTaskSection from './MainTaskSection';
import { useParams } from 'react-router-dom';
import { useProjectDetails } from '../../../dashboard/hooks/useProjectDashboard';
import {
  getClientPortalTaskActivitiesByTaskId,
  getClientPortalTaskById,
  getClientPortalTaskCommentsByTaskId,
} from '../../mockData';
import { ProjectClientPortalData } from '../../types';
import ClientPortalTaskBreadcrumbs from './ClientPortalTaskBreadcrubms';
import useClientPortalService from '../../useClientPortalService';
import { Stack } from '@mui/material';
import CommentsSection from '../comments/CommentsSection';
import ClientActivitySection from '../clientActivity/ClientActivitySection';
import { useClientPortal } from '../../useClientPortal';
import { mapClientPortalTaskComments } from '../comments/commentUtils';
import { ProjectSecurityContext } from 'domain/shared/newProject';

const ViewClientPortalTaskLayout = () => {
  const { id, taskId } = useParams();
  const { project, isDataReloading } = useProjectDetails(id!);
  const {
    data: clientPortalData,
    isDataReloading: isClientPortalDataReloading,
    refetch: refetchClientPortalData,
  } = useClientPortal(id!);
  const projectData = (project || {}) as ProjectClientPortalData;
  const projectClientPortalData: ProjectClientPortalData = {
    ...projectData,
    id: id!,
    clients: clientPortalData?.clientPortal?.users || [],
    tasks: clientPortalData?.clientPortal?.tasks || [],
    taskComments: mapClientPortalTaskComments(clientPortalData?.clientPortal?.taskComments),
    taskActivities: clientPortalData?.clientPortal?.taskActivities || [],
  };
  const task = getClientPortalTaskById(projectClientPortalData, taskId);
  const taskComments = getClientPortalTaskCommentsByTaskId(projectClientPortalData, taskId);
  const taskActivities = getClientPortalTaskActivitiesByTaskId(projectClientPortalData, taskId);
  const { getCreatePortalTaskValidation, updateClientPortalTask } = useClientPortalService();

  if ((isDataReloading || isClientPortalDataReloading) && !task) {
    return <Loading />;
  }

  if (!task) {
    return null;
  }

  return (
    <ProjectSecurityContext permissions={project?.accessInfo}>
      <ShowPageLayout
        breadcrumbs={<ClientPortalTaskBreadcrumbs task={task} projectName={project?.name} />}
        hasSeparateSections
      >
        <FormShowTemplate
          key={`${task.id}-${task.status}`}
          isCreateRequest={false}
          initialData={() => task}
          getDataFunc={() => Promise.resolve(task)}
          mapDataForForm={data => ({
            ...data,
            attachmentIds: (data.attachments || []).map((file: { id: string }) => file.id),
          })}
          submitFormFunc={data => {
            return updateClientPortalTask(id!, taskId!, data, task.attachments);
          }}
          getValidationSchemaFunc={getCreatePortalTaskValidation}
          afterSubmit={{
            message: 'You are awesome! The Client Task has been successfully updated.',
            execute: () => refetchClientPortalData(),
          }}
        >
          <MainTaskSection
            clients={projectClientPortalData.clients}
            refetchClientPortalData={refetchClientPortalData}
          />
        </FormShowTemplate>
        <Stack sx={{ width: '100%', flexDirection: { md: 'row', sm: 'column' } }} gap={4}>
          <CommentsSection
            projectId={id!}
            taskId={task.id}
            initialComments={taskComments}
            refetchComments={refetchClientPortalData}
            taskStatus={task.status}
          />
          <ClientActivitySection activities={taskActivities} />
        </Stack>
      </ShowPageLayout>
    </ProjectSecurityContext>
  );
};
export default ViewClientPortalTaskLayout;
